import React from 'react';
import PropTypes from 'prop-types';
import NotImplemented from '../NotImplemented';
import { PSP_SITE_NAME } from '../../utils/constants';
import { getPspMappedCatalogData, getAvailableProductLines } from './utils';
import PriceAndFinanceUI from './PriceAndFinanceLayout';
import useAppName from '../../hooks/useAppName';
import { useCurrentProductLine } from '../SelectProductsContext/SelectProductsProvider';

const PriceAndFinanceMap = ({ fields }) => {
  const [currentProductLine] = useCurrentProductLine();

  const siteName = useAppName();
  let productCatalogData = [];
  let availableProductLines = [];

  switch (siteName) {
    case PSP_SITE_NAME:
      productCatalogData = getPspMappedCatalogData({
        fieldsData: fields?.data,
        selectedProductLine: currentProductLine,
      });
      availableProductLines = getAvailableProductLines(fields?.data);
      break;
    default:
      return <NotImplemented name="PriceAndFinance" />;
  }

  return <PriceAndFinanceUI productCatalogData={productCatalogData} availableProductLines={availableProductLines} />;
};

PriceAndFinanceMap.propTypes = {
  fields: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
  rendering: PropTypes.shape({}),
};

export default PriceAndFinanceMap;
